// 0草稿，1发布中，2未开始，3已截止
export const STATUS_DRAFT = 0
export const STATUS_PUBLISHING = 1
export const STATUS_NOT_START = 2
export const STATUS_END = 3

export const TEMPLATE_BLANK = 0 // 空白模板

export const STATUS_MAP = {
  [STATUS_DRAFT]: '草稿',
  [STATUS_PUBLISHING]: '发布中',
  [STATUS_NOT_START]: '未开始',
  [STATUS_END]: '已截止'
}

export const WCD_ROUTE_EDIT = 'editor' // 编辑路由
export const WCD_ROUTE_AD = 'advertising' // 投放路由
export const WCD_ROUTE_DATA = 'DataStatistics' // 数据统计路由
export const WCD_ROUTE_PREVIEW = 'preview' // 预览路由

export const SOURCE_HLJ = 2 // 婚礼纪
export const LEAFLET_LINK = '/p/frontend/leaflet_manage/dist/index.html#'
// export const LEAFLET_LINK = 'http://localhost:3001/#'
